export default "__VITE_ASSET__29b53dc6__"